import {
  MockMap,
} from '@ama-sdk/core';
import {
  createMockData,
} from '@dapi/sdk/spec';
import {
  alternativeOfferForUnOnly,
  orderEligibilitiesMockEligibleToRefundWithUnRoundTrip,
  orderForUnOnlyRoundTrip,
} from '../../../mock/data/index';
import {
  flightDisruptionWarning,
  orderNotEligibleForRefundWarning,
} from '../../../mock/dictionaries/index';

export const unOnlyRoundTripMock: MockMap = {
  retrieveOrder: [createMockData(orderForUnOnlyRoundTrip, [], [flightDisruptionWarning])],
  getOrderEligibilities: [createMockData(orderEligibilitiesMockEligibleToRefundWithUnRoundTrip, [], [orderNotEligibleForRefundWarning])],
  getAlternativeOffers: [createMockData(alternativeOfferForUnOnly)]
};
